import SysColumn from "app/class/sys-column";
import SysTable from "app/class/sys-table";
import { permissionFieldProfiles } from "./profiles";
import { PERMISSION_ARRAY_FIELD_TYPE, PermissionFieldProfile } from "./types";

interface ResolvePermissionFieldProfileInput {
    table: SysTable;
    column: SysColumn;
}

export const resolvePermissionFieldProfile = ({ table, column }: ResolvePermissionFieldProfileInput): PermissionFieldProfile | null => {
    const key = `${table.name}.${column.name}`;

    switch (key) {
        case "sys_gate_pages.api_scope_json":
            return permissionFieldProfiles["gate.api_scope.page"];
        case "sys_gate_widgets.api_scope_json":
            return permissionFieldProfiles["gate.api_scope.widget"];
        case "sys_business_rules.capabilities_json":
            return permissionFieldProfiles["runtime.capabilities.business_rule"];
        case "sys_jobs.capabilities_json":
            return permissionFieldProfiles["runtime.capabilities.platform_job"];
        case "sys_api_scripts.capabilities_json":
            return permissionFieldProfiles["runtime.capabilities.dynamic_api_script"];
        case "sys_api_endpoints.api_scope_json":
            return permissionFieldProfiles["dynamic_api.endpoint_scope.freeform"];
        default:
            if (column.column_type === PERMISSION_ARRAY_FIELD_TYPE) {
                return permissionFieldProfiles["dynamic_api.endpoint_scope.freeform"];
            }

            return null;
    }
};
